import { render, staticRenderFns } from "./PayRangeAmountsEditor.vue?vue&type=template&id=3a7ddc7e&scoped=true"
import script from "./PayRangeAmountsEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./PayRangeAmountsEditor.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PayRangeAmountsEditor.vue?vue&type=style&index=0&id=3a7ddc7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7ddc7e",
  null
  
)

export default component.exports